import React, { useState, useEffect } from 'react';
import { ROLES_SISTEMA } from '../../constants/roles';

const EditUserForm = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get('id');

    const [tipoUsuario, setTipoUsuario] = useState('1');
    const [nombreCompleto, setNombreCompleto] = useState('');
    const [telefono, setTelefono] = useState('');
    const [email, setEmail] = useState('');
    const [originalEmail, setOriginalEmail] = useState('');
    const [usuario, setUsuario] = useState('');
    const [rol, setRol] = useState('');
    const [flexSid, setFlexSid] = useState('');
    const [estatusActual, setEstatusActual] = useState('');

    const [coordinadores, setCoordinadores] = useState<any[]>([]);
    const [coordinadorSeleccionado, setCoordinadorSeleccionado] = useState('');
    const [adminsEspeciales, setAdminsEspeciales] = useState<any[]>([]);
    const [adminEspecialSeleccionado, setAdminEspecialSeleccionado] = useState('');
    const [subdirectores, setSubdirectores] = useState<any[]>([]);
    const [subdirectorSeleccionado, setSubdirectorSeleccionado] = useState('');
    const [proveedorSeleccionado, setProveedorSeleccionado] = useState('');

    const [nuevoPassword, setNuevoPassword] = useState('');
    const [confirmarPassword, setConfirmarPassword] = useState('');
    const [nuevoEstatus, setNuevoEstatus] = useState('');

    const [activeTab, setActiveTab] = useState('visibilidad');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [emailStatus, setEmailStatus] = useState<'idle' | 'checking' | 'available' | 'taken' | 'invalid'>('idle');

    const [rolesDisponibles, setRolesDisponibles] = useState<any[]>([]);
    const [clientes, setClientes] = useState<any[]>([]);
    const [proveedores, setProveedores] = useState<any[]>([]);

    const [contratosDisponibles, setContratosDisponibles] = useState<any[]>([]);
    const [flotillasN1, setFlotillasN1] = useState<any[]>([]);
    const [flotillasN2, setFlotillasN2] = useState<any[]>([]);
    const [flotillasN3, setFlotillasN3] = useState<any[]>([]);

    const [permisos, setPermisos] = useState<any[]>([]);
    const [archivos, setArchivos] = useState<any[]>([]);

    const [permisoForm, setPermisoForm] = useState({
        cliente: '', nombreCliente: 'Todos',
        contrato: '', nombreContrato: 'Todos',
        nv1: '', nombreNv1: 'Todos',
        nv2: '', nombreNv2: 'Todos',
        nv3: '', nombreNv3: 'Todos'
    });

    const [archivoForm, setArchivoForm] = useState<{ fileObj: File | null; tipo: string; descripcion: string }>({
        fileObj: null, tipo: '1', descripcion: ''
    });

    useEffect(() => {
        if (!userId) {
            alert("No se proporcionó un ID de usuario.");
            window.location.href = "/usuarioAdmin";
            return;
        }

        fetch('/sittApi/catalogos/obtener_roles.php?tipo=sistema').then(res => res.json()).then(data => setRolesDisponibles(data.data || []));
        fetch('/sittApi/obtener_clientes.php').then(res => res.json()).then(data => setClientes(data.data || []));
        fetch('/sittApi/obtener_usuarios_por_rol.php?key_labels=COORDINADOR,ADMIN_TALLERES').then(res => res.json()).then(data => setCoordinadores(data.data || []));
        fetch('/sittApi/obtener_usuarios_por_rol.php?key_labels=ADMIN_ESPECIAL,SYS_ADMIN,GERENTE_CONTRALORIA,ADMIN_CONTRALORIA').then(res => res.json()).then(data => setAdminsEspeciales(data.data || []));
        fetch('/sittApi/obtener_usuarios_por_rol.php?key_label=SUBDIRECTOR_OPERACIONES').then(res => res.json()).then(data => setSubdirectores(data.data || []));

        fetch(`/sittApi/usuariosAdmin/obtener_usuario.php?id=${userId}`)
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    const u = data.data;
                    setTipoUsuario(u.clave_tipo_usuario?.toString() || '1');
                    setNombreCompleto(u.nombre_completo || '');
                    setTelefono(u.telefono || '');
                    setEmail(u.email || '');
                    setOriginalEmail(u.email || '');
                    setUsuario(u.usuario || '');
                    setRol(u.clave_rol?.toString() || '');
                    setFlexSid(u.extra_data?.flex_sid || '');
                    setCoordinadorSeleccionado(u.clave_coordinador_asignado?.toString() || '');
                    setAdminEspecialSeleccionado(u.clave_admin_especial_asignado?.toString() || '');
                    setSubdirectorSeleccionado(u.clave_subdirector_asignado?.toString() || '');
                    setEstatusActual(u.clave_estatus || 'BLOQ');
                    setPermisos(u.permisos || []);
                } else {
                    alert("Error al cargar el usuario");
                }
                setIsLoading(false);
            })
            .catch(() => {
                alert("Error de conexión al cargar datos.");
                setIsLoading(false);
            });
    }, [userId]);

    useEffect(() => {
        if (!email || email === originalEmail) {
            setEmailStatus('idle');
            return;
        }

        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regexEmail.test(email)) { setEmailStatus('invalid'); return; }

        setEmailStatus('checking');
        const delayDebounceFn = setTimeout(async () => {
            try {
                const response = await fetch(`/api/ajaxResponse/verifCorreo.php`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: `b=${email}`
                });
                const text = await response.text();
                setEmailStatus(text.trim() === "0" ? 'available' : 'taken');
            } catch (error) {
                setEmailStatus('idle');
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [email, originalEmail]);

    const handleClienteChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        const nombre = e.target.options[e.target.selectedIndex].text;
        setPermisoForm({
            ...permisoForm, cliente: id, nombreCliente: id ? nombre : 'Todos',
            contrato: '', nombreContrato: 'Todos',
            nv1: '', nombreNv1: 'Todos',
            nv2: '', nombreNv2: 'Todos',
            nv3: '', nombreNv3: 'Todos'
        });
        setContratosDisponibles([]);
        setFlotillasN1([]);
        setFlotillasN2([]);
        setFlotillasN3([]);

        const formData = new FormData();
        formData.append("action", "filtered");
        formData.append("idCliente", btoa(id));
        fetch(`/api/clientes/contratos.php`, { method: "POST", body: formData }).then(res => res.json()).then(data => setContratosDisponibles(data || []));
    };

    const handleContratoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        if (id != "") {
            const nombre = e.target.options[e.target.selectedIndex].text;
            setPermisoForm({
                ...permisoForm, contrato: id, nombreContrato: nombre,
                nv1: '', nombreNv1: 'Todos',
                nv2: '', nombreNv2: 'Todos',
                nv3: '', nombreNv3: 'Todos'
            });
            setFlotillasN1([]);
            setFlotillasN2([]);
            setFlotillasN3([]);

            const formData = new FormData();
            formData.append("action", "listaNivel1");
            formData.append("clave_persona_cliente", permisoForm.cliente);
            formData.append("clave_cliente_contrato", id);
            fetch(`/api/xajax/ajaxCC.php`, { method: "POST", body: formData }).then(res => res.json()).then(data => setFlotillasN1(data || []));
        }
    };

    const handleNv1Change = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        if (id != "") {
            const nombre = e.target.options[e.target.selectedIndex].text;
            setPermisoForm({
                ...permisoForm, nv1: id, nombreNv1: nombre,
                nv2: '', nombreNv2: 'Todos',
                nv3: '', nombreNv3: 'Todos'
            });
            setFlotillasN2([]);
            setFlotillasN3([]);

            const formData = new FormData();
            formData.append("action", "listaNivel2");
            formData.append("clave_persona_cliente", permisoForm.cliente);
            formData.append("clave_nv1", permisoForm.nv1);
            fetch(`/api/xajax/ajaxCC.php`, { method: "POST", body: formData }).then(res => res.json()).then(data => setFlotillasN2(data || []));
        }
    };

    const handleNv2Change = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        const nombre = e.target.options[e.target.selectedIndex].text;
        setPermisoForm({
            ...permisoForm, nv2: id, nombreNv2: nombre,
            nv3: '', nombreNv3: 'Todos'
        });
        setFlotillasN3([]);

        const formData = new FormData();
        formData.append("action", "listaNivel3");
        formData.append("clave_persona_cliente", permisoForm.cliente);
        formData.append("clave_nv3", permisoForm.nv1);
        fetch(`/api/xajax/ajaxCC.php`, { method: "POST", body: formData }).then(res => res.json()).then(data => setFlotillasN3(data || []));
    };

    const handleNv3Change = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        const nombre = e.target.options[e.target.selectedIndex].text;
        setPermisoForm({ ...permisoForm, nv3: id, nombreNv3: nombre });
    };

    const agregarPermiso = () => {
        setPermisos([...permisos, { ...permisoForm }]);
        setPermisoForm({ cliente: '', nombreCliente: 'Todos', contrato: '', nombreContrato: 'Todos', nv1: '', nombreNv1: 'Todos', nv2: '', nombreNv2: 'Todos', nv3: '', nombreNv3: 'Todos' });
    };

    const eliminarPermiso = (indexToRemove: number) => {
        setPermisos(permisos.filter((_, index) => index !== indexToRemove));
    };

    const agregarArchivo = () => {
        if (!archivoForm.fileObj) {
            alert("Debe seleccionar un archivo."); return;
        }
        setArchivos([...archivos, { ...archivoForm, id_temp: Date.now() }]);
        setArchivoForm({ fileObj: null, tipo: '1', descripcion: '' });
        const fileInput = document.getElementById('fileUploaderUser') as HTMLInputElement;
        if (fileInput) fileInput.value = '';
    };

    const eliminarArchivo = (identificador: number) => {
        setArchivos(archivos.filter(a => (a.id_temp || a.clave_archivo || a.id_archivo) !== identificador));
    };

    const handleSubmit = async () => {
        const rolObj = rolesDisponibles.find(r => String(r.clave_rol) === String(rol));
        const esEjecutivo = rolObj?.key_label === ROLES_SISTEMA.EJECUTIVO_FLOTILLA;

        if (emailStatus === 'taken') { alert("El correo ya esta en uso."); return; }
        if (emailStatus === 'invalid') { alert("El correo no es válido."); return; }
        if (email === "" || nombreCompleto === "" || rol === "") { alert("Llene los campos obligatorios."); return; }

        if (esEjecutivo && coordinadorSeleccionado === "") {
            alert("Debe asignar un aprobador de nivel Coordinador (Coordinador o Admin Talleres).");
            return;
        }

        if (esEjecutivo && adminEspecialSeleccionado === "") {
            alert("Debe asignar un aprobador de nivel Admin. Especial (Admin Especial, SYS Admin o Contraloría).");
            return;
        }

        if (esEjecutivo && subdirectorSeleccionado === "") {
            alert("Debe asignar un subdirector de operaciones para el perfil de ejecutivo.");
            return;
        }

        setIsSubmitting(true);

        try {
            const formData = new FormData();
            formData.append('id_usuario', userId!);
            formData.append('clave_tipo_usuario', tipoUsuario);
            formData.append('nombre_completo', nombreCompleto);
            formData.append('telefono', telefono);
            formData.append('email', email);
            formData.append('usuario', usuario);
            formData.append('clave_rol', rol);
            formData.append('flex_sid', flexSid);
            formData.append('procesar_permisos', '1');

            if (esEjecutivo) {
                formData.append('clave_coordinador_asignado', coordinadorSeleccionado);
                formData.append('clave_admin_especial_asignado', adminEspecialSeleccionado);
                formData.append('clave_subdirector_asignado', subdirectorSeleccionado);
            }

            if (tipoUsuario === '4') formData.append('clave_persona_proveedor', proveedorSeleccionado);

            permisos.forEach((permiso, index) => {
                const getId = (keyBackend: string, keyFront: string) => {
                    const val = permiso[keyBackend] !== undefined ? permiso[keyBackend] : permiso[keyFront];
                    return (val === 'Todos' || val === 'all' || val === null || val === undefined) ? '' : val;
                };

                formData.append(`permiso_id[${index}]`, permiso.clave_permiso || permiso.id_permiso || '0');
                formData.append(`permiso_clave_persona_cliente[${index}]`, getId('clave_persona_cliente', 'cliente'));
                formData.append(`permiso_clave_cliente_contrato[${index}]`, getId('clave_cliente_contrato', 'contrato'));
                formData.append(`permiso_clave_nv1[${index}]`, getId('clave_nv1', 'nv1'));
                formData.append(`permiso_clave_nv2[${index}]`, getId('clave_nv2', 'nv2'));
                formData.append(`permiso_clave_nv3[${index}]`, getId('clave_nv3', 'nv3'));
            });

            archivos.forEach((archivo, index) => {
                formData.append(`archivero_archivos_clave_tipo_archivo[${index}]`, archivo.tipo);
                formData.append(`archivero_archivos_descripcion[${index}]`, archivo.descripcion);
                formData.append(`file_${index}`, archivo.fileObj);
            });

            const response = await fetch('/sittApi/usuariosAdmin/editar_usuario.php', { method: 'POST', body: formData });
            const result = await response.json();

            if (result.status === 'success') {
                alert("Información actualizada correctamente.");
                window.location.reload();
            } else {
                alert(result.message);
            }
        } catch (error) {
            alert("Ocurrió un error al comunicarse con el servidor.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubAccion = async (subaccion: string, extraData: any = {}) => {
        if (!confirm(`¿Desea proceder con la acción: ${subaccion}?`)) return;

        const formData = new FormData();
        formData.append('subaccion', subaccion);
        formData.append('id', userId!);
        Object.keys(extraData).forEach(key => formData.append(key, extraData[key]));

        try {
            const response = await fetch(`/usuarioAdmin?accion=edit&id=${userId!}`, { method: 'POST', body: formData });
            if (response.ok) {
                alert("Acción realizada con éxito.");
                window.location.reload();
            } else {
                alert("Ocurrió un problema en el servidor.");
            }
        } catch (e) {
            alert("Error de comunicación.");
        }
    }

    if (isLoading) return <div className="p-5 text-center"><i className="fas fa-spinner fa-spin fa-3x text-primary"></i><p>Cargando información...</p></div>;

    return (
        <div className="container-fluid px-0">
            <div className="row g-3">
                <div className="col-xl-9">
                    <div className="card shadow-sm border-0 h-100">
                        <div className="card-header border-bottom py-3">
                            <h5 className="mb-0 fw-bold"><i className="fas fa-user-edit text-primary me-2"></i> Editar Usuario: {usuario}</h5>
                        </div>

                        <div className="card-body p-4">
                            <div className="row g-4">
                                <div className="col-xl-5">
                                    <div className="card shadow-none border h-100">
                                        <div className="card-body">
                                            <h6 className="fw-bold text-primary mb-3 text-uppercase small">Datos Generales</h6>

                                            <div className="mb-3">
                                                <label className="form-label small fw-bold text-secondary mb-1">Tipo de usuario</label>
                                                <select className="form-select form-select-sm" value={tipoUsuario} onChange={e => setTipoUsuario(e.target.value)} disabled={isSubmitting}>
                                                    <option value="1">Usuario SITT</option>
                                                </select>
                                            </div>

                                            {tipoUsuario === '4' && (
                                                <div className="mb-3 animate__animated animate__fadeIn">
                                                    <label className="form-label small fw-bold text-secondary mb-1">Proveedor asignado *</label>
                                                    <select className="form-select form-select-sm border-warning" required value={proveedorSeleccionado} onChange={e => setProveedorSeleccionado(e.target.value)} disabled={isSubmitting}>
                                                        <option value="">Seleccione el proveedor...</option>
                                                        {proveedores.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                                                    </select>
                                                </div>
                                            )}

                                            <div className="mb-3">
                                                <label className="form-label small fw-bold text-secondary mb-1">Nombre completo *</label>
                                                <input type="text" className="form-control form-control-sm" required value={nombreCompleto} onChange={e => setNombreCompleto(e.target.value)} disabled={isSubmitting} />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label small fw-bold text-secondary mb-1">Teléfono</label>
                                                <input type="text" className="form-control form-control-sm" value={telefono} onChange={e => setTelefono(e.target.value)} disabled={isSubmitting} />
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor='email' className="form-label small fw-bold text-secondary mb-1">E-mail *</label>
                                                <div className="input-group input-group-sm">
                                                    <input id='email' type="email"
                                                        className={`form-control ${emailStatus === 'available' ? 'is-valid' : emailStatus === 'taken' || emailStatus === 'invalid' ? 'is-invalid' : ''}`}
                                                        required value={email} onChange={e => setEmail(e.target.value)} disabled={isSubmitting} />
                                                    {emailStatus === 'checking' && <span className="input-group-text"><i className="fas fa-spinner fa-spin text-primary"></i></span>}
                                                </div>
                                                {emailStatus === 'taken' && <div className="invalid-feedback d-block small">Este correo ya está en uso.</div>}
                                                {emailStatus === 'invalid' && <div className="invalid-feedback d-block small">Formato inválido.</div>}
                                            </div>

                                            <hr className="my-4" />
                                            <h6 className="fw-bold text-primary mb-3 text-uppercase small">Credenciales de Acceso</h6>

                                            <div className="mb-3">
                                                <label className="form-label small fw-bold text-secondary mb-1">Usuario (Solo lectura)</label>
                                                <input type="text" className="form-control form-control-sm" value={usuario} readOnly />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label small fw-bold text-secondary mb-1">Rol en el sistema *</label>
                                                <select className="form-select form-select-sm" required value={rol} onChange={e => setRol(e.target.value)} disabled={isSubmitting}>
                                                    <option value="">Seleccione el rol...</option>
                                                    {rolesDisponibles.map(r => (
                                                        <option key={r.clave_rol} value={r.clave_rol}>{r.rol}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {rolesDisponibles.find(r => String(r.clave_rol) === String(rol))?.key_label === ROLES_SISTEMA.EJECUTIVO_FLOTILLA && (
                                                <>
                                                <div className="mb-3 animate__animated animate__fadeInDown">
                                                    <label className="form-label small fw-bold text-primary mb-1">Aprobador nivel Coordinador *</label>
                                                    <select className="form-select form-select-sm border-primary" required value={coordinadorSeleccionado} onChange={e => setCoordinadorSeleccionado(e.target.value)} disabled={isSubmitting}>
                                                        <option value="">Seleccione al aprobador...</option>
                                                        {coordinadores.map(c => (
                                                            <option key={c.clave_usuario} value={c.clave_usuario}>{c.nombre_completo} - {c.usuario} ({c.rol || c.key_label})</option>
                                                        ))}
                                                    </select>
                                                    <div className="form-text text-muted" style={{ fontSize: '0.70rem' }}>Roles: Coordinador o Admin Talleres. Aprueba OT ≤ $15,000</div>
                                                </div>
                                                <div className="mb-3 animate__animated animate__fadeInDown">
                                                    <label className="form-label small fw-bold text-primary mb-1">Aprobador nivel Admin. Especial *</label>
                                                    <select className="form-select form-select-sm border-primary" required value={adminEspecialSeleccionado} onChange={e => setAdminEspecialSeleccionado(e.target.value)} disabled={isSubmitting}>
                                                        <option value="">Seleccione al aprobador...</option>
                                                        {adminsEspeciales.map(c => (
                                                            <option key={c.clave_usuario} value={c.clave_usuario}>{c.nombre_completo} - {c.usuario} ({c.rol || c.key_label})</option>
                                                        ))}
                                                    </select>
                                                    <div className="form-text text-muted" style={{ fontSize: '0.70rem' }}>Roles: Admin Especial, SYS Admin o Contraloría. Aprueba OT &gt; $15,000 y &lt; $50,000</div>
                                                </div>
                                                <div className="mb-3 animate__animated animate__fadeInDown">
                                                    <label className="form-label small fw-bold text-primary mb-1">Subdirector de Operaciones *</label>
                                                    <select className="form-select form-select-sm border-primary" required value={subdirectorSeleccionado} onChange={e => setSubdirectorSeleccionado(e.target.value)} disabled={isSubmitting}>
                                                        <option value="">Seleccione al subdirector...</option>
                                                        {subdirectores.map(c => (
                                                            <option key={c.clave_usuario} value={c.clave_usuario}>{c.nombre_completo} - {c.usuario}</option>
                                                        ))}
                                                    </select>
                                                    <div className="form-text text-muted" style={{ fontSize: '0.70rem' }}>Aprueba OT ≥ $50,000</div>
                                                </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-7">
                                    <div className="card shadow-none border h-100">
                                        <div className="card-header p-0 border-bottom">
                                            <ul className="nav nav-tabs border-0 px-3 pt-2">
                                                <li className="nav-item">
                                                    <button type="button" className={`nav-link border-0 ${activeTab === 'visibilidad' ? 'active fw-bold text-primary border-bottom border-primary border-3' : 'text-muted'}`} onClick={() => setActiveTab('visibilidad')}><i className="far fa-eye me-1"></i> Visibilidad y Contratos</button>
                                                </li>
                                                <li className="nav-item">
                                                    <button type="button" className={`nav-link border-0 ${activeTab === 'archivos' ? 'active fw-bold text-primary border-bottom border-primary border-3' : 'text-muted'}`} onClick={() => setActiveTab('archivos')}><i className="far fa-folder me-1"></i> Expediente</button>
                                                </li>
                                                <li className="nav-item">
                                                    <button type="button" className={`nav-link border-0 ${activeTab === 'flex' ? 'active fw-bold text-primary border-bottom border-primary border-3' : 'text-muted'}`} onClick={() => setActiveTab('flex')}><i className="far fa-headset me-1"></i> Integración Twilio Flex</button>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="card-body">
                                            {activeTab === 'visibilidad' && (
                                                <div className="row animate__animated animate__fadeIn">
                                                    <div className="col-md-5 border-end pe-3">
                                                        <h6 className="fw-bold small text-uppercase mb-3">Agregar Permiso</h6>

                                                        <div className="mb-2">
                                                            <label className="form-label small text-secondary mb-1">Cliente</label>
                                                            <select className="form-select form-select-sm" value={permisoForm.cliente} onChange={handleClienteChange}>
                                                                <option value="">Todos los clientes</option>
                                                                {clientes.map(c => <option key={c.clave_persona_cliente} value={c.clave_persona_cliente}>{c.nombre_completo}</option>)}
                                                            </select>
                                                        </div>

                                                        <div className="mb-2">
                                                            <label className="form-label small text-secondary mb-1">Contrato</label>
                                                            <select className="form-select form-select-sm" value={permisoForm.contrato} onChange={handleContratoChange} disabled={!permisoForm.cliente}>
                                                                <option value="">Todos los contratos</option>
                                                                {contratosDisponibles.map(c => <option key={c.clave_cliente_contrato} value={c.clave_cliente_contrato}>{c.nombre}</option>)}
                                                            </select>
                                                        </div>

                                                        {contratosDisponibles.length > 0 && (
                                                            <>
                                                                <div className="mb-2">
                                                                    <label className="form-label small text-secondary mb-1">Nivel 1</label>
                                                                    <select className="form-select form-select-sm" value={permisoForm.nv1} onChange={handleNv1Change} disabled={!permisoForm.contrato || flotillasN1.length == 0}>
                                                                        <option value="">{flotillasN1.length > 0 ? "Elegir..." : "Sin niveles"}</option>
                                                                        {flotillasN1.map(c => <option key={c.clave_nv1} value={c.clave_nv1}>{c.descripcion_nv1}</option>)}
                                                                    </select>
                                                                </div>

                                                                {flotillasN1.length > 0 && (
                                                                    <>
                                                                        <div className="mb-2">
                                                                            <label className="form-label small text-secondary mb-1">Nivel 2</label>
                                                                            <select className="form-select form-select-sm" value={permisoForm.nv2} onChange={handleNv2Change} disabled={!permisoForm.nv1 || flotillasN2.length == 0}>
                                                                                <option value="">{flotillasN2.length > 0 ? "Elegir..." : "Sin niveles"}</option>
                                                                                {flotillasN2.map(c => <option key={c.clave_nv2} value={c.clave_nv2}>{c.descripcion_nv2}</option>)}
                                                                            </select>
                                                                        </div>

                                                                        {flotillasN2.length > 0 && (
                                                                            <div className="mb-2">
                                                                                <label className="form-label small text-secondary mb-1">Nivel 3</label>
                                                                                <select className="form-select form-select-sm" value={permisoForm.nv3} onChange={handleNv3Change} disabled={!permisoForm.nv2 || flotillasN3.length == 0}>
                                                                                    <option value="">{flotillasN3.length > 0 ? "Elegir..." : "Sin niveles"}</option>
                                                                                    {flotillasN3.map(c => <option key={c.clave_nv3} value={c.clave_nv3}>{c.descripcion_nv3}</option>)}
                                                                                </select>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                        <button type="button" className="btn btn-outline-primary btn-sm w-100 mt-3 fw-bold" onClick={agregarPermiso} disabled={isSubmitting}>
                                                            <i className="fas fa-plus me-1"></i> Asignar
                                                        </button>
                                                    </div>

                                                    <div className="col-md-7 ps-3">
                                                        <div className="table-responsive">
                                                            <table className="table table-hover table-sm align-middle border">
                                                                <thead className="text-secondary small">
                                                                    <tr>
                                                                        <th>Cliente</th>
                                                                        <th>Contrato</th>
                                                                        <th>Nivel 1</th>
                                                                        <th>Nivel 2</th>
                                                                        <th>Nivel 3</th>
                                                                        <th className="text-center"><i className="fas fa-cog"></i></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {permisos.map((p, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="small">{p.nombreCliente ?? p.cliente}</td>
                                                                                <td className="small">{p.nombreContrato ?? p.contrato}</td>
                                                                                <td className="small">{p.nombreNv1 ?? p.flotilla_nv1}</td>
                                                                                <td className="small">{p.nombreNv2 ?? p.flotilla_nv2}</td>
                                                                                <td className="small">{p.nombreNv3 ?? p.flotilla_nv3}</td>
                                                                                <td className="text-center">
                                                                                    <button type="button" className="btn btn-sm btn-link text-danger p-0" onClick={() => eliminarPermiso(index)}>
                                                                                        <i className="fas fa-trash-alt"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeTab === 'archivos' && (
                                                <div className="row animate__animated animate__fadeIn">
                                                    <div className="col-md-5 border-end pe-3">
                                                        <h6 className="fw-bold small text-uppercase mb-3">Adjuntar Documento</h6>
                                                        <div className="mb-2">
                                                            <label className="form-label small text-secondary mb-1">Archivo</label>
                                                            <input id="fileUploaderUser" type="file" className="form-control form-control-sm" onChange={e => setArchivoForm({ ...archivoForm, fileObj: e.target.files?.[0] || null })} disabled={isSubmitting} />
                                                        </div>
                                                        <div className="mb-2">
                                                            <label className="form-label small text-secondary mb-1">Clasificación</label>
                                                            <select className="form-select form-select-sm" value={archivoForm.tipo} onChange={e => setArchivoForm({ ...archivoForm, tipo: e.target.value })} disabled={isSubmitting}>
                                                                <option value="1">Identificación Oficial (INE/IFE)</option>
                                                                <option value="2">Comprobante de Domicilio</option>
                                                                <option value="3">Contrato Firmado</option>
                                                            </select>
                                                        </div>
                                                        <div className="mb-3">
                                                            <label className="form-label small text-secondary mb-1">Descripción corta</label>
                                                            <textarea className="form-control form-control-sm" rows={2} value={archivoForm.descripcion} onChange={e => setArchivoForm({ ...archivoForm, descripcion: e.target.value })} disabled={isSubmitting}></textarea>
                                                        </div>
                                                        <button type="button" className="btn btn-outline-primary btn-sm w-100 fw-bold" onClick={agregarArchivo} disabled={isSubmitting || !archivoForm.fileObj}>
                                                            <i className="fas fa-upload me-1"></i> Subir a Expediente
                                                        </button>
                                                    </div>

                                                    <div className="col-md-7 ps-3">
                                                        <div className="table-responsive">
                                                            <table className="table table-hover table-sm align-middle border">
                                                                <thead className=" text-secondary small">
                                                                    <tr>
                                                                        <th>Documento Nuevo</th>
                                                                        <th className="text-center"><i className="fas fa-cog"></i></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {archivos.length === 0 ? (
                                                                        <tr><td colSpan={2} className="text-center text-muted py-4 fst-italic">Sin documentos nuevos.</td></tr>
                                                                    ) : (
                                                                        archivos.map(a => (
                                                                            <tr key={a.id_temp}>
                                                                                <td className="small">
                                                                                    <span className="fw-bold text-primary"><i className="fas fa-file-alt me-2"></i>{a.fileObj?.name}</span><br />
                                                                                    <span className="text-muted">{a.tipo === '1' ? 'INE' : a.tipo === '2' ? 'Domicilio' : 'Contrato'}</span>
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    <button type="button" className="btn btn-sm btn-link text-danger p-0" onClick={() => eliminarArchivo(a.id_temp)}><i className="fas fa-trash-alt"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeTab === 'flex' && (
                                                <div className="row animate__animated animate__fadeIn">
                                                    <div className="col-md-8">
                                                        <h6 className="fw-bold small text-uppercase mb-3">Parámetros de Integración</h6>
                                                        <div className="mb-3">
                                                            <label className="form-label small fw-bold text-secondary mb-1">SID de Trabajador (Flex)</label>
                                                            <input type="text" className="form-control form-control-sm" placeholder="WKxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" value={flexSid} onChange={e => setFlexSid(e.target.value)} disabled={isSubmitting} />
                                                            <div className="form-text" style={{ fontSize: '0.75rem' }}>Necesario únicamente para usuarios tipo Call Center que requieran recibir llamadas.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card-footer border-top py-3 text-end">
                            <a href="/usuarioAdmin" className="btn btn-secondary border text-muted px-4 me-2 fw-bold">Cancelar</a>
                            <button type="button" onClick={handleSubmit} className="btn btn-success px-5 fw-bold shadow-sm" disabled={isSubmitting || emailStatus === 'taken'}>
                                {isSubmitting ? <><i className="fas fa-spinner fa-spin me-2"></i> Guardando...</> : <><i className="fas fa-save me-2"></i> Actualizar Perfil</>}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-xl-3">
                    <div className="d-flex flex-column gap-3">

                        <div className="card shadow-sm border-0">
                            <div className="card-header border-bottom py-2"><h6 className="mb-0 fw-bold">Cambiar contraseña</h6></div>
                            <div className="card-body p-3">
                                <div className="mb-2">
                                    <label className="form-label small text-secondary mb-1">Nueva Contraseña</label>
                                    <input type="password" placeholder="Min. 8 chars, 1 Mayus, 1 Num" className="form-control form-control-sm" value={nuevoPassword} onChange={e => setNuevoPassword(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label small text-secondary mb-1">Confirmar Contraseña</label>
                                    <input type="password" placeholder="Repetir contraseña" className="form-control form-control-sm" value={confirmarPassword} onChange={e => setConfirmarPassword(e.target.value)} />
                                </div>
                                <button type="button" className="btn btn-success btn-sm w-100 fw-bold"
                                    onClick={() => {
                                        if (nuevoPassword !== confirmarPassword) return alert("Las contraseñas no coinciden.");
                                        if (nuevoPassword === usuario) return alert("La contraseña no puede ser igual al usuario.");
                                        handleSubAccion('password', { password: nuevoPassword, password2: confirmarPassword });
                                    }}
                                >Actualizar Contraseña</button>
                            </div>
                        </div>

                        <div className="card shadow-sm border-0">
                            <div className="card-header border-bottom py-2"><h6 className="mb-0 fw-bold">Recuperar contraseña</h6></div>
                            <div className="card-body p-3 text-center">
                                <p className="small text-muted mb-3">Enviará un token al correo registrado.</p>
                                <button type="button" className="btn btn-outline-primary btn-sm w-100 fw-bold" onClick={() => handleSubAccion('recovery')}>Enviar Correo</button>
                            </div>
                        </div>

                        <div className="card shadow-sm border-0">
                            <div className="card-header border-bottom py-2"><h6 className="mb-0 fw-bold">Estatus del Acceso</h6></div>
                            <div className="card-body p-3">
                                <div className="mb-3">
                                    <label className="form-label small text-secondary mb-1">Estatus actual: <span className="badge bg-secondary">{estatusActual}</span></label>
                                    <select className="form-select form-select-sm" value={nuevoEstatus} onChange={e => setNuevoEstatus(e.target.value)}>
                                        <option value="">Cambiar a...</option>
                                        <option value="ACTI">Activo</option>
                                        <option value="BLOQ">Bloqueado</option>
                                    </select>
                                </div>
                                <button type="button" className="btn btn-primary btn-sm w-100 fw-bold" disabled={!nuevoEstatus} onClick={() => handleSubAccion('status', { clave_estatus: nuevoEstatus })}>Cambiar Estatus</button>
                            </div>
                        </div>

                        {estatusActual !== 'CANC' && (
                            <div className="card shadow-sm border-0 border-danger">
                                <div className="card-body p-3 text-center">
                                    <p className="small text-danger mb-3 fw-bold"><i className="fas fa-exclamation-triangle me-1"></i> Zona de Riesgo</p>
                                    <button type="button" className="btn btn-danger btn-sm w-100 fw-bold" onClick={() => handleSubAccion('delete')}>Eliminar Usuario</button>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditUserForm;